var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":("https://www.atropin.cn" + (_vm.$route.query.qrcode))}})]),_c('div',{staticClass:"hint"},[_vm._v("请使用支付宝扫描完成支付")])])}
var staticRenderFns = []

export { render, staticRenderFns }